import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
  static values = {
    inviteUuid: String,
    sliderSelector: { type: String, default: "#book-slider-author" },
  }

  declare inviteUuidValue: string
  declare sliderSelectorValue: string

  private checkInterval: number | null = null

  connect() {
    if (!this.inviteUuidValue) {
      return
    }

    this.waitForSliderAndPlayVoiceMessage()
  }

  disconnect() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
    }
  }

  private waitForSliderAndPlayVoiceMessage() {
    const sliderElement =
      this.element.querySelector(this.sliderSelectorValue) ||
      document.querySelector(this.sliderSelectorValue)

    const slider = sliderElement as HTMLElement | null

    if (!slider) {
      return
    }

    this.checkInterval = window.setInterval(() => {
      if ($(slider).hasClass("slick-initialized")) {
        if (this.checkInterval) {
          clearInterval(this.checkInterval)
          this.checkInterval = null
        }

        setTimeout(() => {
          this.playVoiceMessage(slider)
        }, 500)
      }
    }, 100)
  }

  private playVoiceMessage(slider: HTMLElement) {
    // Find the slide with the invite's UUID
    const inviteSlide = slider.querySelector(
      `#about-slide-${this.inviteUuidValue}`,
    ) as HTMLElement | null

    if (!inviteSlide) {
      return
    }

    // Navigate to this slide
    const allSlides = slider.querySelectorAll(".slide")
    const slideIndex = Array.from(allSlides).indexOf(inviteSlide)
    if (slideIndex >= 0) {
      $(slider).slick("slickGoTo", slideIndex)
    }

    // Find the audio recorder and play button
    setTimeout(() => {
      const audioRecorder = inviteSlide.querySelector(
        `[data-audio-recorder-invite-uuid-value="${this.inviteUuidValue}"]`,
      ) as HTMLElement | null

      if (!audioRecorder) {
        return
      }

      const playButton = audioRecorder.querySelector(".audio-recorder__play") as HTMLElement | null

      if (playButton) {
        playButton.click()
      } else {
        // Fallback: try to play the audio directly
        const audioPlayer = audioRecorder.querySelector(
          '[data-audio-recorder-target="audioPlayer"]',
        ) as HTMLAudioElement | null

        if (audioPlayer && audioPlayer.src) {
          audioPlayer.play().catch((error) => {
            console.error("Error playing voice message:", error)
          })
        }
      }
    }, 500)
  }
}
